import React from "react";

const RedUnlock = ({ onClickHandle }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClickHandle}
  >
    <path
      d="M16.733 10.9885L15.5861 10.7032L16.1567 8.40949C16.713 6.17311 15.3776 3.95328 13.1412 3.39697C10.9048 2.84066 8.685 4.17609 8.12869 6.41247L7.55811 8.7062L6.41125 8.42091L6.98183 6.12718C7.69505 3.26003 10.5593 1.53689 13.4265 2.25011C16.2937 2.96333 18.0168 5.82763 17.3036 8.69478L16.733 10.9885Z"
      fill="#961B01"
    />
    <path
      d="M17.2272 20.8636H7.77272C6.76818 20.8636 6 20.0954 6 19.0909V12C6 10.9955 6.76818 10.2273 7.77272 10.2273H17.2272C18.2318 10.2273 18.9999 10.9955 18.9999 12V19.0909C18.9999 20.0954 18.2318 20.8636 17.2272 20.8636ZM7.77272 11.4091C7.41817 11.4091 7.18181 11.6455 7.18181 12V19.0909C7.18181 19.4454 7.41817 19.6818 7.77272 19.6818H17.2272C17.5818 19.6818 17.8181 19.4454 17.8181 19.0909V12C17.8181 11.6455 17.5818 11.4091 17.2272 11.4091H7.77272Z"
      fill="#961B01"
    />
    <path
      d="M12.4982 14.9544C13.1509 14.9544 13.68 14.4253 13.68 13.7726C13.68 13.1199 13.1509 12.5908 12.4982 12.5908C11.8455 12.5908 11.3164 13.1199 11.3164 13.7726C11.3164 14.4253 11.8455 14.9544 12.4982 14.9544Z"
      fill="#961B01"
    />
    <path
      d="M12.7951 13.7727H12.2042L11.6133 17.3181H13.386L12.7951 13.7727Z"
      fill="#961B01"
    />
  </svg>
);

export default RedUnlock;
